import { render, staticRenderFns } from "./mJlzx.vue?vue&type=template&id=f00c166e&scoped=true&"
import script from "./mJlzx.vue?vue&type=script&lang=js&"
export * from "./mJlzx.vue?vue&type=script&lang=js&"
import style0 from "./mJlzx.vue?vue&type=style&index=0&id=f00c166e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00c166e",
  null
  
)

export default component.exports